import { useState } from 'react';
import { useGetAllMyInteractions } from '@/shared/hooks/useInteractions';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { InteractionsTable } from '@/features/interactions/table/InteractionsTable';
import { InteractionsFilters } from '@/features/interactions/filters/InteractionsFilters';
import { PageHeader } from '@/shared/components/PageHeader';
import type { FilterState } from '@/features/interactions/table/types/interaction-table.types';

export const Route = createFileRoute('/_dashboard/interactions/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('common');
  const { data: allMyInteractions, isLoading } = useGetAllMyInteractions();

  const [filters, setFilters] = useState<FilterState>({
    type: 'all',
    status: 'all',
    search: '',
    dateFrom: '',
    dateTo: '',
  });

  return (
    <div className="min-h-screen">
      <PageHeader title={t('myInteractions')} icon={Users} />

      <div className="mx-4 py-6 sm:mx-6 lg:mx-8">
        <div className="container mx-auto space-y-6">
          <InteractionsFilters filters={filters} onFiltersChange={setFilters} />

          <InteractionsTable
            interactions={allMyInteractions || []}
            filters={filters}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
